<template lang="pug">
div.kennel-count-internal(
	:class="{error:(count && count < 0), loading:(count === null)}"
	:style="`background-color:${color}; --square-color:${color2};`"
)
	//- :class="[`bg-color-${countForBG}`]"
	div.dia {{ day }}
		.interno.quanto.loading(v-if="count === null") ...
		.interno.quanto.zero(v-else-if="count === 0")
			include ../resources/icons/close.pug
		.interno.quanto.warn(v-else-if="count < 0") {{ count }}
		.interno(v-else)
			.quanto {{ count }}
			.txt available
</template>


<script setup lang="ts">
import { events } from '@/events';
import { useKennelCount } from '@/store/kennelCounts';
import { Dogspaces } from '@busy-human/k9-library';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';


const props = defineProps<{day: number, month: number, year: number, kennel: Dogspaces.Sizes}>();
const kennelStore = useKennelCount();

// If count is null, number hasn't loaded
const count = ref<number | null>(null);

// const MAX_COLOR_INDEX = 4;

const colors = {
	"small":    "#00B2FF", // cyan
	"medium":   "#3300FF", // blue
	"large":    "#BD00FF", // fuchia
	// "large":    "#FF0037",
	"x-large":    "#FF6B00", // orange
	"xx-large":  "#DDFF00", // yellow
	// "green": "#00FF66", // green
};

// const countForBG = computed(() => Math.max(0, Math.min(count.value || 0, MAX_COLOR_INDEX)));

const opacityHexValue = [
	"00", "1A", "33", "4D", "66", "80", "99", "B3", "CC", "E6", "FF"
];

// Color based on kennel size + opacity; ie: 5 small kennels available = #00B2FF80
const color = computed(()=>`${colors[props.kennel]}${opacityHexValue[Math.min((count.value || 0), 10)]}`);
const color2 = computed(()=>`${colors[props.kennel]}`);

const countKey = computed(() => kennelStore.kennelCountKey(props.year, props.month + 1, props.day));

async function fetchCount() {
	count.value = null;
	const foundCount = await kennelStore.getKennelCount(countKey.value, props.kennel);
	count.value = foundCount;
}

onMounted(() => {
	console.log( " ON MOUNTED< PROPS: ", props);
	events.on("kennel:reload", fetchCount);
}

);
onUnmounted(() => events.off("kennel:reload", fetchCount));

watch(() => props, async () => {
	await fetchCount();
}, {deep: true, immediate: true});
</script>

<style lang="scss">
// $bg-colors: #C0ECFF, #9AE1FF, #7ED8FF, #7ED8FF;

// /* Disabling stylelint rule here because it's sass */
// /* stylelint-disable-next-line at-rule-no-unknown */
// @for $i from 1 through length($bg-colors) {
// 	/* stylelint-disable-next-line scss/no-global-function-names, function-no-unknown */
// 	$c: nth($bg-colors, $i);

// 	.bg-color-#{$i} {
// 		background-color: $c;
// 	}
// }

.kennel-count-internal {
	position: relative;
    box-sizing: border-box;
	display: flex;
    align-items: center;
	height: 100%;
    padding: 0.25rem;
	font-size: 1.25em;
	border: 2px dashed transparent;


	&, .interno{
		transition: all 50ms ease ;
		transform: translateY(0) scale(1);
	}

	.dia{
    	position: absolute;
		inset: 0.5rem 0.25rem;
	}

	.interno{
		width: fit-content;
		padding:  0.25em;
		margin: auto;
		text-align: center;
	}


	.quanto{
		font-size: 2em;
	}

	.quanto, .txt{
		text-align: center;
	}

	.txt{
		padding-top: .5rem;
		line-height: 1em;
	}

	.loading{
		font-size: 1rem;
		color: rgba($color-black, 0.5)
	}
}

.kennel-count-internal:hover {
	/* stylelint-disable-next-line color-function-notation */
	background : rgba(var(--square-color), 1);
	border-color: var(--square-color);

	.interno{
		transform: translateY(-0.25rem) scale(1.05);
	}
}

.kennel-count-internal.error {
	color: $color-red;
}

.kennel-count-internal.error:hover {
	border-color: rgba($color-red, 0.5);
}
</style>
